import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '@UI/antd/Modal'
import { rootActions } from '@store/slices'
import { RootState } from '@store/store'
import Support from '../Support'
import styles from './index.scss'

const SupportModal = () => {
    const dispatch = useDispatch()
    const onClose = () =>
        dispatch(
            rootActions.ui.common.onChangeItems({
                supportModalVisible: false,
                userMenuVisible: false
            })
        )
    const { supportModalVisible } = useSelector((state: RootState) => state.ui.common)
    return (
        <Modal
            open={supportModalVisible}
            onCancel={onClose}
            modalSize="medium"
            footer={false}
            style={{ top: 20 }}
            maskClosable
        >
            <div className={styles.modalMain}>
                <Support onClose={onClose} />
            </div>
        </Modal>
    )
}

export default SupportModal
